import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/store";
import {
  setCommisionRate,
  setCurrency,
  setPaymentFrequency,
} from "../../reducer/registrationReducer";
import { setPaymentSettingModal } from "../../reducer/modalReducer";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

function PaymentSettingModal() {
  const dispatch = useDispatch();
  const { paymentFrequency, commisionRate, currency } = useSelector(
    (state: RootState) => state.registration
  );
  const { paymentSettingsModal } = useSelector(
    (state: RootState) => state.modal
  );

  const [frequency, setFrequency] = useState<string>(paymentFrequency);
  const [commision, setCommision] = useState<string>(commisionRate);
  const [moneyType, setMoneyType] = useState<string>(currency);

  const currencies = ["USD", "EUR", "GBP", "JPY", "CAD"];

  const handleSaveChanges = () => {
    dispatch(setPaymentFrequency(frequency));
    dispatch(setCommisionRate(commision));
    dispatch(setCurrency(moneyType));
    dispatch(setPaymentSettingModal(false));
  };

  const handleCancelEdit = () => {
    dispatch(setPaymentSettingModal(false));
  };

  const handleBackdropClick = (event: any) => {
    if (event.target === event.currentTarget) {
      handleCancelEdit();
    }
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 w-full h-full items-center justify-center bg-gray-500 bg-opacity-75 ${
        paymentSettingsModal ? "flex" : "hidden"
      } `}
      onClick={handleBackdropClick}
    >
      <div className={Classname.modalContent}>
        <div className={Classname.title}>Edit payment settings</div>
        <div className="mb-0">Payment frequency</div>
        <FormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={frequency}
            className="h-10 mt-2"
            onChange={(e) => setFrequency(e.target.value)}
          >
            <MenuItem value="Daily">Daily</MenuItem>
            <MenuItem value="Weekly">Weekly</MenuItem>
            <MenuItem value="Monthly">Monthly</MenuItem>
          </Select>
        </FormControl>
        <div className="mt-3">Commision rate (%)</div>
        <input
          type="number"
          value={commision}
          min={0}
          max={100}
          onChange={(e) => {
            const value = Math.min(
              100,
              Math.max(0, parseInt(e.target.value) || 0)
            );
            setCommision(String(value));
          }}
          className={Classname.input}
        />
        <div className="mb-0 mt-4">Currency</div>
        <FormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={moneyType}
            className="h-10 mt-2"
            onChange={(e) => setMoneyType(e.target.value)}
          >
            {currencies?.map((money, index) => (
              <MenuItem value={money} key={index}>
                {money}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <div className={Classname.justifyEnd}>
          <button onClick={handleCancelEdit} className={Classname.button}>
            Cancel
          </button>
          <button onClick={handleSaveChanges} className={Classname.saveButton}>
            Save changes
          </button>
        </div>
      </div>
    </div>
  );
}

export default PaymentSettingModal;

const Classname = {
  modalContent:
    "bg-white p-6 mx-2 w-full max-w-[500px] rounded shadow-md max-h-[90vh] overflow-scroll",
  title: "font-bold mb-4",
  input: "w-full border border-gray-300 p-2 mt-2 rounded-md h-10",
  button: "px-4 py-2 rounded-lg border-blue-500 border",
  saveButton: "ml-2 bg-blue-500 text-white px-4 py-2 rounded-lg",
  justifyEnd: "mt-4 flex justify-end",
};
